import { ReactNode, useState } from "react";
import cx from "classnames";

import { IconComponent } from "types/Icon";
import Box from "ds/components/Box";

import styles from "./styles.module.css";
import TableCell, { TableCellProps } from "../Cell";
import TableCellContentActions from "./Actions";

export type TableCellAction = {
  icon: IconComponent;
  title: string;
  action: () => void;
};

export type TableCellContentProps = {
  id: string;
  children: ReactNode;
  actions?: TableCellAction[];
  className?: string;
} & Pick<TableCellProps, "role" | "stickyRight" | "stickyLeft">;

const TableCellContent = ({
  id,
  children,
  actions,
  role,
  stickyRight,
  stickyLeft,
  className,
}: TableCellContentProps) => {
  const [isActive, setIsActive] = useState(false);

  const hasActions = actions && actions.length > 0;

  return (
    <TableCell
      id={id}
      className={cx(
        styles.cellContent,
        { [styles.interactive]: hasActions },
        { [styles.active]: isActive },
        className
      )}
      role={role}
      stickyRight={stickyRight}
      stickyLeft={stickyLeft}
      padding="x-large"
      align="center"
    >
      <Box direction="row" align="center" justify="between" gap="medium" fullWidth>
        <Box fullWidth>{children}</Box>
        {hasActions && <TableCellContentActions actions={actions} onOpenChange={setIsActive} />}
      </Box>
    </TableCell>
  );
};

TableCellContent.displayName = "DS.TableCellContent";

export default TableCellContent;
